
	import Vue from 'vue'
	import $ from 'jquery'
	
	import Ticker from '../utils/ticker.js'
	import Scroller from '../utils/scroller.js'
	import Globals from '~utils/Globals.js'

	

	class Scrollable{

		mounted () {
			
			this.offset = 0
			this.bounds = {
				top: 0,
				height: 0,
				bottom: 0
			}
			this.active = false
			this.perc = 0
			this.progress = 0
			this.isResized = false
			
			if (Globals.isLoaded ) {
				this.init()
			}

			this._bind()
			this.$events.on('app.loaded', this.init);

		}

		beforeDestroy () {
			this._off()
		}

		init() {

			this.scroller = new Scroller()
			this.ticker = new Ticker()
			
			this._on()
			

			this._resize()
		}

		initTimeline () {

			this.fakeAnim = {value:0}

			this.tl = new TimelineMax({paused: true})
			this.tl.time(this.progress)

			this.tlAppear = new TimelineMax({paused: true})
		}

		_bind() {
			this.init = this.init.bind(this)
			this.resize = this._resize.bind(this)
		}

		_on () {
			this.scroller.register(this)
			this.$events.on('app.resize', this._resize);
		}

		raf (y) {
			this.isInViewport = this.scroller.isInViewport(this.bounds.top, this.bounds.height)
			if (!this.isInViewport && (this.perc >= 1 || this.perc <= 0)) return
			this.perc = this.boundsAnim ? this.scroller.getPerc(this.boundsAnim, y) : 0
			this.tl && this.tl.progress(this.perc)
		}

		_off () {
			console.log('off')
			this.$events.off('app.loaded');
			this.$events.off('app.resize');
			this.scroller.unRegister(this)
		}

		_resize () {
	
			this.bounds.top = Math.floor($(this.$el).offset().top - this.scroller.scroll.lerped)
			this.bounds.height = this.$el.getBoundingClientRect().height
			this.bounds.bottom = this.bounds.top + this.bounds.height
			
			if (this.tl) {
				this.progress = this.tl.time();
				this.tl.kill();
			}
			
			if (this.tlAppear) {
				this.tlAppear.kill();
			}

			this.isResized = false

		}

	}

	export default Scrollable


// WEBPACK FOOTER //
// ./src/abstracts/scrollable.js